function boldBeforeColon() {
  document.querySelectorAll('.rte li, .rte p').forEach(function(el) {
    if (el.querySelector('strong')) return;
    if (el.querySelector('a')) return;
    var text = el.innerHTML.trim();
    var colonIdx = text.indexOf(':');
    if (colonIdx > 0 && colonIdx < 80) {
      el.innerHTML = '<strong>' + text.substring(0, colonIdx) + ':</strong>' + text.substring(colonIdx + 1);
    }
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', boldBeforeColon);

// Run again after a short delay for dynamically rendered content
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(boldBeforeColon, 500);
});

// Run when collapsible rows are toggled open
document.addEventListener('click', function(e) {
  if (e.target.closest('.collapsible-row, .collapsible, [data-collapsible]')) {
    setTimeout(boldBeforeColon, 300);
  }
});